import { Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Progress from "../../../components/MoveableProgressBar/moveableProgresBar";
import { useState, useEffect, useCallback } from "react";
import { customStep, nextStep, update } from "../../../slice/jobSlice";
import { useDispatch, useSelector } from "react-redux";
import showToast from "../../../components/Hot-Toast/showToast";
import { useTMutation } from "../../../utils/useTMutation";

const SelectJobCommission = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { step, jobData } = useSelector((state) => state.job);
    const [barValue, setBarValue] = useState(jobData?.COMMISSION_PERCENTAGE || 25);
    useEffect(() => {
        setBarValue(jobData?.COMMISSION_PERCENTAGE || 25);
    }, [jobData]);

    const { mutateAsync } = useTMutation("/job/addUpdateJob", "post", (data) => data);

    const onSubmitNext = useCallback(async () => {
        try {
            const response = await mutateAsync({
                COMMISSION_PERCENTAGE: barValue,
                ID: jobData.ID,
                STEP: jobData.REDIRECT ? 8 : step + 1,
            });

            if (response.STATUS) {
                if (jobData.REDIRECT) {
                    dispatch(customStep(8));

                } else {
                    if (jobData.STAFFING_SOLUTION === "DirectHire") {
                        dispatch(customStep(3))
                    } else {
                        dispatch(nextStep())
                    }
                    // dispatch(nextStep());
                }
                dispatch(update({ COMMISSION_PERCENTAGE: barValue, REDIRECT: false }));
            } else {
                showToast("error", response.MESSAGE, 3000);
            }
        } catch (error) {
            console.error("Request failed:", error.message);
            showToast("error", "Something went wrong, please try again", 3000);
        }
    }, [barValue, jobData, step, mutateAsync, dispatch]);

    return (
        <Grid container alignItems="center" px={3} pb={3}>
            <Grid item xs={12} sm={6}>
                <Typography variant="h3" className="about-texts">
                    Direct Hire Placement fees you are most likely to pay?
                </Typography>
            </Grid>
            <Grid item lg={12} xs={12} sm={6} mt={4} justifyContent="center">
                <Progress
                    onChange={(e) => setBarValue(e >= 10 ? e : 10)}
                    value={barValue}
                />
                <Typography variant="h3" className="about-texts">
                    {`${barValue} %`}
                </Typography>
            </Grid>
            <Grid item xs={12} mt={2} sm={6} md={12} lg={12} style={{ justifyContent: "end", display: "flex" }}>
                <Button
                    // variant="contained"
                    // sx={{
                    //     backgroundColor: 'linear-gradient(to right,#4eb3e8,#6ebe44)',
                    //     color: 'white',
                    //     '&:hover': {
                    //         backgroundColor: '#5ca736',
                    //     },
                    // }}
                    className="custombuttons"
                    onClick={onSubmitNext}
                >
                    Next
                </Button>
            </Grid>
        </Grid>
    );
};

export default SelectJobCommission;
